import { UI } from "@wwimmo/ui";
import { useCallback } from "react";
import * as Sentry from "@sentry/react";
import { observer } from "mobx-react-lite";
import styles from "./AddAssemblyRealestateButton.module.css";
import { useTranslation } from "react-i18next";

interface AddAssemblyRealestatesButtonProps {
    onClick: () => void;
}

const AddAssemblyRealestateButtonBase = (props: AddAssemblyRealestatesButtonProps) => {
    const { t } = useTranslation();
    const { onClick, } = props;

    const onClickAddAssemblyRealestateModal = useCallback((e: any) => {
        e.preventDefault();
        onClick();
    }, [onClick]);

    return (
        <UI.Button
            label={t("screens.realestate.assembly.add_realestate")}
            onClick={onClickAddAssemblyRealestateModal}
            className={`${styles.AddRealestatesButton} ml-sm-2 mt-2 mt-sm-0`}
        ></UI.Button>
    );
};

export const AddAssemblyRealestateButton = Sentry.withProfiler(observer(AddAssemblyRealestateButtonBase));
